import { createRouter, createWebHistory } from "vue-router";
import utils from "../plugins/utils.js";

const routes = [
  {
    path: "/",
    redirect: "/index",
  },
  {
    path: "/home",
    component: () => import("../views/Home.vue"),
  },
  {
    path: "/demo",
    component: () => import("../views/Dome.vue"),
  },
  {
    path: "/login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/index",
    component: () => import("../views/index.vue"),
  },
  {
    path: "/materialManager",
    component: () => import("../views/page/MaterialManage"),
    group: "basis",
    title: "材质管理",
  },
  {
    path: "/defectManagement",
    component: () => import("../views/page/DefectManage.vue"),
    group: "basis",
    title: "缺陷管理",
  },
  {
    path: "/productManagement",
    component: () => import("../views/page/ProductManage.vue"),
    group: "basis",
    title: "产品管理",
  },
  {
    path: "/furnaceNumberManagement",
    component: () => import("../views/page/FurnaceNumberManage"),
    group: "furnaceNo",
    title: "炉号管理",
  },
  {
    path: "/createFurnace",
    component: () => import("../views/index.vue"),
    group: "furnaceNo",
    title: "创建炉号",
  },
  {
    path: "/inspectionReport",
    component: () => import("../views/index.vue"),
    group: "furnaceNo",
    title: "探伤报工",
  },
  {
    path: "/traceControl",
    component: () => import("../views/page/FurnaceNumberManage/Trace.vue"),
    group: "mdm",
    title: "追溯管理",
  },
  {
    path: "/inspection",
    component: () => import("../views/page/Inspection.vue"),
    group: "mdm",
    title: "探伤次数数据",
  },
  {
    path: "/inspectionData",
    component: () => import("../views/index.vue"),
    group: "mdm",
    title: "探伤数据",
  },
  {
    path: "/factoryCheck",
    component: () => import("../views/page/FactoryCheck"),
    group: "mdm",
    title: "出厂交验",
  },
  {
    path: "/furnaceStatistics",
    component: () => import("../views/page/FurnaceStatistics.vue"),
    group: "mdm",
    title: "炉号探伤数据统计接口",
  },
  {
    path: "/operation",
    component: () => import("../views/mobilePage/Operation.vue"),
    title: "操作",
  },
  {
    path: "/selectProduct",
    component: () => import("../views/mobilePage/SelectProduct.vue"),
    title: "选择产品",
  },
  {
    path: "/userMange",
    component: () => import("../views/page/User.vue"),
    title: "用户管理",
  },
  {
    path: "/scrap",
    component: () => import("../views/page/Scrap"),
    title: "提交报废",
  },
  {
    path: "/daily",
    component: () => import("../views/page/Daily.vue"),
    title: "探伤日报",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  // 如果用户访问的登录页，直接放行
  if (to.path === "/login") return next();
  // 从 sessionStorage 中获取到 保存的 token 值
  const tokenStr = window.sessionStorage.getItem("token");
  // 没有 token,强制跳转到登录页
  if (!tokenStr) return next("/login");
  next();
});

export default router;
